// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';

// class names utility
import cx from 'classnames';

export default function PasswordValidator (props) {
  return (
    <div className={`${cx('password-validator', {valid: props.valid})} ${props.className}`}>
      {props.label}
    </div>
  );
}

PasswordValidator.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  valid: PropTypes.bool
};



// WEBPACK FOOTER //
// ./shared/common/components/f_PasswordWithValidators/f_PasswordValidator/index.js